import styled from "styled-components";

export const ProgressText = styled.p`
  color: #5f7483;
  font-size: 13px;
  padding-bottom: 5px;
  letter-spacing: 0;
  line-height: 16px;
`;
